export default "__VITE_PUBLIC_ASSET__2b77a7c8__"